import React from "react";
import { connect } from "react-redux";
import { Icon, Input } from "antd";
import { compose } from "recompose";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Form, FormItem } from "@worcket/common/components/controls";
import { withForm, isLoading } from "@worcket/common/hocs";

import Centered from "../components/display/Centered";
import { login, LOGIN } from "../store/actions/session";
import logo from "../assets/logo-blue.svg";
import Button from "../components/Button";

import styled from "styled-components/macro";

const Container = styled(Form)`
  min-width: 260px;
  h3 {
    text-align: center;
    margin-bottom: 16px;
  }

  .ant-form-item-label {
    line-height: 24px;
  }

  .logo {
    margin-bottom: 24px;
    display: flex;
    justify-content: center;

    img {
      max-width: 170px;
    }
  }

  .login {
    width: 100%;
  }

  .options {
    justify-content: center;
    align-items: center;
    display: flex;
    flex-direction: column;
  }

  .recover-password-link {
    text-align: center;
    display: block;
    margin-bottom: 21px;
  }

  .ant-form-item-label > label {
    color: ${({ theme }) => theme["@gray-60"]};
  }
`;

const Title = styled.h3`
  font-size: 16px;
  font-weight: 400;
`;

const Login = ({ form, onSubmit, loading }) => {
  const { t } = useTranslation();
  return (
    <Centered contentStyle={{ maxWidth: 304 }}>
      <Container onSubmit={onSubmit} hideRequiredMark={true}>
        <div className="logo">
          <img src={logo} alt="Worcket" />
        </div>
        <Title>{t("components:Login.enterCredentials")}</Title>
        <FormItem
          form={form}
          label={t("global:email")}
          name="emailAddress"
          rules={[
            { transform: value => value && value.trim() },
            {
              required: true,
              message: t("form:emptyFieldValidation")
            },
            {
              type: "email",
              message: t("form:validEmail")
            }
          ]}
          render={
            <Input
              disabled={loading}
              prefix={<Icon type="mail" style={{ color: "rgba(0,0,0,.25)" }} />}
              autoComplete="email"
            />
          }
        />
        <FormItem
          form={form}
          label={t("global:password")}
          name="password"
          rules={[
            {
              required: true,
              message: t("components:Login.pleaseEnterPassword")
            }
          ]}
          render={
            <Input.Password
              disabled={loading}
              prefix={<Icon type="lock" style={{ color: "rgba(0,0,0,.25)" }} />}
              autoComplete="current-password"
            />
          }
        />
        <Link to="/olvide-mi-contraseña" className="recover-password-link">
          {t("components:Login.forgotPassword")}
        </Link>
        <Button
          loading={loading}
          className="login"
          size="xl"
          type="primary"
          htmlType="submit"
        >
          {t("components:Login.logIn")}
        </Button>
      </Container>
    </Centered>
  );
};

const enhancer = compose(
  connect(
    undefined,
    { login }
  ),
  isLoading(LOGIN),
  withForm({
    onSubmit: (values, { login }) => login(values)
  })
);

export default enhancer(Login);
